import { theme } from '../../theme';
import {
  StyledBroadsiderStats,
  BroadsiderStat,
  BroadsiderStatIconHolder,
  BroadsiderStatValueHolder,
  CritValueHolder,
  CritIndicator,
  BaseValueHolder,
  DecreasedStat,
  BaseValue,
  BaseValueButton,
  SpeedValueHolder,
  SpeedIndicator
} from './BroadsiderStats.styled';

const BaseStat = ({ value, decreased = 0 }) => {
  const realValue = value - decreased;
  return (
    <BaseValueHolder>
      <BaseValue $width={`${realValue}%`}/>
      <BaseValueButton/>
      <DecreasedStat style={{width: `${decreased}%`}}/>
    </BaseValueHolder>
  );
};

const SpeedStat = ({ value }) => {
  const count = Math.floor(value / 20);
  const opacities = [];
  for (let i = 0; i < count; i++) {
    opacities.push(`${(i + 1) * 0.2}`);
  }
  return (
    <SpeedValueHolder>
      {opacities.map((o, index) => <SpeedIndicator key={index} />)}
    </SpeedValueHolder>
  );
};

const CritStat = ({ value }) => {
  const count = Math.floor(value / 20);
  const opacities = [];
  for (let i = 0; i < count; i++) {
    opacities.push(`${(i + 1) * 0.2}`);
  }
  return (
    <CritValueHolder>
      {opacities.map((o, index) => <CritIndicator key={index} ><img src='/assets/skull_violet.svg' style={{opacity: `${(index + 1) * 0.1 + 0.5}`}}/></CritIndicator>)}
    </CritValueHolder>
  );
};

const BroadsiderStats = ({ stats, modifiers }) => {
  const MIN_VALUE = 0;
  const MAX_VALUE = 2200;
  const MIN_CRIT_VALUE = 0;
  const MAX_CRIT_VALUE = 40;

  const healthValue = Math.floor(stats.healthPoints / (MAX_VALUE - MIN_VALUE) * 100);
  const attackValue = Math.floor(stats.attackPoints / (MAX_VALUE - MIN_VALUE) * 100);
  const defenceValue = Math.floor(stats.defencePoints / (MAX_VALUE - MIN_VALUE) * 100);
  const speedValue = Math.floor(stats.speed / (MAX_VALUE - MIN_VALUE) * 100);
  const critChanceValue = Math.floor(stats.criticalChance / (MAX_CRIT_VALUE - MIN_CRIT_VALUE) * 100);

  const healthDecreased = 100 - Math.floor((healthValue * modifiers.healthMultiplier + modifiers.healthPoints) / healthValue * 100);

  return (
    <StyledBroadsiderStats>
      <BroadsiderStat $decreased={healthDecreased > 0}>
        <BroadsiderStatIconHolder style={{ background: theme.buttonLight }}>
          <img src='/assets/stat_icon_health.svg'/>
        </BroadsiderStatIconHolder>
        <BroadsiderStatValueHolder>
          <BaseStat value={healthValue} decreased={healthDecreased}/>
        </BroadsiderStatValueHolder>
      </BroadsiderStat>
      <BroadsiderStat>
        <BroadsiderStatIconHolder style={{ background: theme.buttonLight }}>
          <img src='/assets/stat_icon_weapon.svg'/>
        </BroadsiderStatIconHolder>
        <BroadsiderStatValueHolder>
          <BaseStat value={attackValue}/>
        </BroadsiderStatValueHolder>
      </BroadsiderStat>
      <BroadsiderStat>
        <BroadsiderStatIconHolder style={{ background: theme.buttonLight }}>
          <img src='/assets/stat_icon_armour.svg'/>
        </BroadsiderStatIconHolder>
        <BroadsiderStatValueHolder>
          <BaseStat value={defenceValue}/>
        </BroadsiderStatValueHolder>
      </BroadsiderStat>
      <BroadsiderStat>
        <BroadsiderStatIconHolder style={{ background: theme.brightYellow }}>
          <img src='/assets/stat_icon_speed.svg'/>
        </BroadsiderStatIconHolder>
        <BroadsiderStatValueHolder>
          <SpeedStat value={speedValue}/>
        </BroadsiderStatValueHolder>
      </BroadsiderStat>
      <BroadsiderStat>
        <BroadsiderStatIconHolder style={{ background: theme.baseViolet }}>
          <img src='/assets/stat_icon_crit.svg'/>
        </BroadsiderStatIconHolder>
        <BroadsiderStatValueHolder>
          <CritStat value={critChanceValue}/>
        </BroadsiderStatValueHolder>
      </BroadsiderStat>
    </StyledBroadsiderStats>
  );
};

export default BroadsiderStats;
